import m from 'mithril'

export default {
  view: vnode => {
    const skitse = require('./skitse.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-34-page`}>                
            <figure className="log-book-figure">
            <img src={skitse} className="log-book-img" />    
            <figcaption className="log-book-figcaption">
            Skitse over affyringsrampe til atommissiler. Den amerikanske hær ønsker at placere 600 ramper i et kæmpe netværk af tunneller under indlandsisen.
            </figcaption>
          </figure>  
      </div>
    )
  }
}
